import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';

const DisplayModal = ({ open, onClose, name, children }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{name}</DialogTitle>

      <DialogContent sx={{ maxHeight: '75vh', overflowY: 'auto' }}>
        {children} {/* This renders the content passed as children */}
      </DialogContent>

      <DialogActions sx={{ padding: 2 }}>
        <Button onClick={onClose} variant="false">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DisplayModal;
